[
  {
    "name": "Afghanistan",
    "prefix": "+93",
    "code": "AF",
    "icon": "🇦🇫"
  },
  {
    "name": "Aland Islands",
    "prefix": "+358",
    "code": "AX",
    "icon": "🇦🇽"
  },
  {
    "name": "Albania",
    "prefix": "+355",
    "code": "AL",
    "icon": "🇦🇱",
    "names": {
      "de": "Albanien"
    }
  },
  {
    "name": "Algeria",
    "prefix": "+213",
    "code": "DZ",
    "icon": "🇩🇿",
    "names": {
      "de": "Algerien"
    }
  },
  {
    "name": "AmericanSamoa",
    "prefix": "+1684",
    "code": "AS",
    "icon": "🇦🇸",
    "names": {
      "it": "Samoa Americane",
      "en": "American Samoa",
      "de": "Amerikanisch-Samoa"
    }
  },
  {
    "name": "Andorra",
    "prefix": "+376",
    "code": "AD",
    "icon": "🇦🇩"
  },
  {
    "name": "Angola",
    "prefix": "+244",
    "code": "AO",
    "icon": "🇦🇴"
  },
  {
    "name": "Anguilla",
    "prefix": "+1264",
    "code": "AI",
    "icon": "🇦🇮"
  },
  {
    "name": "Antarctica",
    "prefix": "+672",
    "code": "AQ",
    "icon": "🇦🇶"
  },
  {
    "name": "Antigua and Barbuda",
    "prefix": "+1268",
    "code": "AG",
    "icon": "🇦🇬",
    "names": {
      "it": "Antigua e Barbuda",
      "de": "Antigua und Barbuda"
    }
  },
  {
    "name": "Argentina",
    "prefix": "+54",
    "code": "AR",
    "icon": "🇦🇷",
    "names": {
      "de": "Argentinien"
    }
  },
  {
    "name": "Armenia",
    "prefix": "+374",
    "code": "AM",
    "icon": "🇦🇲",
    "names": {
      "de": "Armenien"
    }
  },
  {
    "name": "Aruba",
    "prefix": "+297",
    "code": "AW",
    "icon": "🇦🇼"
  },
  {
    "name": "Australia",
    "prefix": "+61",
    "code": "AU",
    "icon": "🇦🇺",
    "names": {
      "de": "Australien"
    }
  },
  {
    "name": "Austria",
    "prefix": "+43",
    "code": "AT",
    "icon": "🇦🇹",
    "names": {
      "de": "Österreich"
    }
  },
  {
    "name": "Azerbaijan",
    "prefix": "+994",
    "code": "AZ",
    "icon": "🇦🇿",
    "names": {
      "it": "Azerbaigian",
      "de": "Aserbaidschan"
    }
  },
  {
    "name": "Bahamas",
    "prefix": "+1242",
    "code": "BS",
    "icon": "🇧🇸"
  },
  {
    "name": "Bahrain",
    "prefix": "+973",
    "code": "BH",
    "icon": "🇧🇭"
  },
  {
    "name": "Bangladesh",
    "prefix": "+880",
    "code": "BD",
    "icon": "🇧🇩",
    "names": {
      "de": "Bangladesch"
    }
  },
  {
    "name": "Barbados",
    "prefix": "+1246",
    "code": "BB",
    "icon": "🇧🇧"
  },
  {
    "name": "Belarus",
    "prefix": "+375",
    "code": "BY",
    "icon": "🇧🇾",
    "names": {
      "it": "Bielorussia",
      "de": "Weißrussland"
    }
  },
  {
    "name": "Belgium",
    "prefix": "+32",
    "code": "BE",
    "icon": "🇧🇪",
    "names": {
      "it": "Belgio",
      "de": "Belgien"
    }
  },
  {
    "name": "Belize",
    "prefix": "+501",
    "code": "BZ",
    "icon": "🇧🇿"
  },
  {
    "name": "Benin",
    "prefix": "+229",
    "code": "BJ",
    "icon": "🇧🇯"
  },
  {
    "name": "Bermuda",
    "prefix": "+1441",
    "code": "BM",
    "icon": "🇧🇲"
  },
  {
    "name": "Bhutan",
    "prefix": "+975",
    "code": "BT",
    "icon": "🇧🇹"
  },
  {
    "name": "Bolivia, Plurinational State of",
    "prefix": "+591",
    "code": "BO",
    "icon": "🇧🇴",
    "names": {
      "it": "Bolivia",
      "en": "Bolivia",
      "de": "Bolivien"
    }
  },
  {
    "name": "Bosnia and Herzegovina",
    "prefix": "+387",
    "code": "BA",
    "icon": "🇧🇦",
    "names": {
      "it": "Bosnia-Erzegovina",
      "de": "Bosnien und Herzegowina"
    }
  },
  {
    "name": "Botswana",
    "prefix": "+267",
    "code": "BW",
    "icon": "🇧🇼",
    "names": {
      "de": "Botsuana"
    }
  },
  {
    "name": "Brazil",
    "prefix": "+55",
    "code": "BR",
    "icon": "🇧🇷",
    "names": {
      "it": "Brasile",
      "de": "Brasilien"
    }
  },
  {
    "name": "British Indian Ocean Territory",
    "prefix": "+246",
    "code": "IO",
    "icon": "🇮🇴",
    "names": {
      "it": "Territorio britannico dell'oceano Indiano",
      "de": "Britisches Territorium im Indischen Ozean"
    }
  },
  {
    "name": "Brunei Darussalam",
    "prefix": "+673",
    "code": "BN",
    "icon": "🇧🇳",
    "names": {
      "it": "Brunei",
      "en": "Brunei",
      "de": "Brunei"
    }
  },
  {
    "name": "Bulgaria",
    "prefix": "+359",
    "code": "BG",
    "icon": "🇧🇬",
    "names": {
      "de": "Bulgarien"
    }
  },
  {
    "name": "Burkina Faso",
    "prefix": "+226",
    "code": "BF",
    "icon": "🇧🇫"
  },
  {
    "name": "Burundi",
    "prefix": "+257",
    "code": "BI",
    "icon": "🇧🇮"
  },
  {
    "name": "Cambodia",
    "prefix": "+855",
    "code": "KH",
    "icon": "🇰🇭",
    "names": {
      "it": "Cambogia",
      "de": "Kambodscha"
    }
  },
  {
    "name": "Cameroon",
    "prefix": "+237",
    "code": "CM",
    "icon": "🇨🇲",
    "names": {
      "it": "Camerun",
      "de": "Kamerun"
    }
  },
  {
    "name": "Canada",
    "prefix": "+1",
    "code": "CA",
    "icon": "🇨🇦",
    "names": {
      "de": "Kanada"
    }
  },
  {
    "name": "Cape Verde",
    "prefix": "+238",
    "code": "CV",
    "icon": "🇨🇻",
    "names": {
      "it": "Capo Verde",
      "en": "Cabo Verde",
      "de": "Kap Verde"
    }
  },
  {
    "name": "Cayman Islands",
    "prefix": "+ 345",
    "code": "KY",
    "icon": "🇰🇾",
    "names": {
      "it": "Isole Cayman",
      "de": "Kaimaninseln"
    }
  },
  {
    "name": "Central African Republic",
    "prefix": "+236",
    "code": "CF",
    "icon": "🇨🇫",
    "names": {
      "it": "Repubblica Centrafricana",
      "de": "Zentralafrikanische Republik"
    }
  },
  {
    "name": "Chad",
    "prefix": "+235",
    "code": "TD",
    "icon": "🇹🇩",
    "names": {
      "it": "Ciad",
      "de": "Tschad"
    }
  },
  {
    "name": "Chile",
    "prefix": "+56",
    "code": "CL",
    "icon": "🇨🇱",
    "names": {
      "it": "Cile"
    }
  },
  {
    "name": "China",
    "prefix": "+86",
    "code": "CN",
    "icon": "🇨🇳",
    "names": {
      "it": "Cina"
    }
  },
  {
    "name": "Christmas Island",
    "prefix": "+61",
    "code": "CX",
    "icon": "🇨🇽"
  },
  {
    "name": "Cocos (Keeling) Islands",
    "prefix": "+61",
    "code": "CC",
    "icon": "🇨🇨"
  },
  {
    "name": "Colombia",
    "prefix": "+57",
    "code": "CO",
    "icon": "🇨🇴",
    "names": {
      "de": "Kolumbien"
    }
  },
  {
    "name": "Comoros",
    "prefix": "+269",
    "code": "KM",
    "icon": "🇰🇲",
    "names": {
      "it": "Comore",
      "de": "Komoren"
    }
  },
  {
    "name": "Congo",
    "prefix": "+242",
    "code": "CG",
    "icon": "🇨🇬",
    "names": {
      "it": "Repubblica del Congo",
      "en": "Republic of the Congo",
      "de": "Republik Kongo"
    }
  },
  {
    "name": "Congo, The Democratic Republic of the Congo",
    "prefix": "+243",
    "code": "CD",
    "icon": "🇨🇩",
    "names": {
      "it": "Repubblica Democratica del Congo",
      "en": "Democratic Republic of the Congo",
      "de": "Demokratische Republik Kongo"
    }
  },
  {
    "name": "Cook Islands",
    "prefix": "+682",
    "code": "CK",
    "icon": "🇨🇰",
    "names": {
      "it": "Isole Cook",
      "de": "Cookinseln"
    }
  },
  {
    "name": "Costa Rica",
    "prefix": "+506",
    "code": "CR",
    "icon": "🇨🇷"
  },
  {
    "name": "Cote d'Ivoire",
    "prefix": "+225",
    "code": "CI",
    "icon": "🇨🇮",
    "names": {
      "it": "Costa d'Avorio",
      "en": "Ivory Coast",
      "de": "Elfenbeinküste"
    }
  },
  {
    "name": "Croatia",
    "prefix": "+385",
    "code": "HR",
    "icon": "🇭🇷",
    "names": {
      "it": "Croazia",
      "de": "Kroatien"
    }
  },
  {
    "name": "Cuba",
    "prefix": "+53",
    "code": "CU",
    "icon": "🇨🇺",
    "names": {
      "de": "Kuba"
    }
  },
  {
    "name": "Cyprus",
    "prefix": "+357",
    "code": "CY",
    "icon": "🇨🇾",
    "names": {
      "it": "Cipro",
      "de": "Zypern"
    }
  },
  {
    "name": "Czech Republic",
    "prefix": "+420",
    "code": "CZ",
    "icon": "🇨🇿",
    "names": {
      "it": "Repubblica Ceca",
      "en": "Czechia",
      "de": "Tschechien"
    }
  },
  {
    "name": "Denmark",
    "prefix": "+45",
    "code": "DK",
    "icon": "🇩🇰",
    "names": {
      "it": "Danimarca",
      "de": "Dänemark"
    }
  },
  {
    "name": "Djibouti",
    "prefix": "+253",
    "code": "DJ",
    "icon": "🇩🇯",
    "names": {
      "it": "Gibuti",
      "de": "Dschibuti"
    }
  },
  {
    "name": "Dominica",
    "prefix": "+1767",
    "code": "DM",
    "icon": "🇩🇲",
    "names": {
      "it": "Dominìca"
    }
  },
  {
    "name": "Dominican Republic",
    "prefix": "+1849",
    "code": "DO",
    "icon": "🇩🇴",
    "names": {
      "it": "Repubblica Dominicana",
      "de": "Dominikanische Republik"
    }
  },
  {
    "name": "Ecuador",
    "prefix": "+593",
    "code": "EC",
    "icon": "🇪🇨"
  },
  {
    "name": "Egypt",
    "prefix": "+20",
    "code": "EG",
    "icon": "🇪🇬",
    "names": {
      "it": "Egitto",
      "de": "Ägypten"
    }
  },
  {
    "name": "El Salvador",
    "prefix": "+503",
    "code": "SV",
    "icon": "🇸🇻"
  },
  {
    "name": "Equatorial Guinea",
    "prefix": "+240",
    "code": "GQ",
    "icon": "🇬🇶",
    "names": {
      "it": "Guinea Equatoriale",
      "de": "Äquatorialguinea"
    }
  },
  {
    "name": "Eritrea",
    "prefix": "+291",
    "code": "ER",
    "icon": "🇪🇷"
  },
  {
    "name": "Estonia",
    "prefix": "+372",
    "code": "EE",
    "icon": "🇪🇪",
    "names": {
      "de": "Estland"
    }
  },
  {
    "name": "Ethiopia",
    "prefix": "+251",
    "code": "ET",
    "icon": "🇪🇹",
    "names": {
      "it": "Etiopia",
      "de": "Äthiopien"
    }
  },
  {
    "name": "Falkland Islands (Malvinas)",
    "prefix": "+500",
    "code": "FK",
    "icon": "🇫🇰",
    "names": {
      "it": "Isole Falkland (Isole Malvine)",
      "en": "Falkland Islands",
      "de": "Falklandinseln"
    }
  },
  {
    "name": "Faroe Islands",
    "prefix": "+298",
    "code": "FO",
    "icon": "🇫🇴",
    "names": {
      "it": "Isole Fær Øer",
      "de": "Färöer"
    }
  },
  {
    "name": "Fiji",
    "prefix": "+679",
    "code": "FJ",
    "icon": "🇫🇯",
    "names": {
      "it": "Figi",
      "de": "Fidschi"
    }
  },
  {
    "name": "Finland",
    "prefix": "+358",
    "code": "FI",
    "icon": "🇫🇮",
    "names": {
      "it": "Finlandia",
      "de": "Finnland"
    }
  },
  {
    "name": "France",
    "prefix": "+33",
    "code": "FR",
    "icon": "🇫🇷",
    "names": {
      "it": "Francia",
      "de": "Frankreich"
    }
  },
  {
    "name": "French Guiana",
    "prefix": "+594",
    "code": "GF",
    "icon": "🇬🇫"
  },
  {
    "name": "French Polynesia",
    "prefix": "+689",
    "code": "PF",
    "icon": "🇵🇫"
  },
  {
    "name": "Gabon",
    "prefix": "+241",
    "code": "GA",
    "icon": "🇬🇦",
    "names": {
      "de": "Gabun"
    }
  },
  {
    "name": "Gambia",
    "prefix": "+220",
    "code": "GM",
    "icon": "🇬🇲",
    "names": {
      "en": "The Gambia"
    }
  },
  {
    "name": "Georgia",
    "prefix": "+995",
    "code": "GE",
    "icon": "🇬🇪",
    "names": {
      "de": "Georgien"
    }
  },
  {
    "name": "Germany",
    "prefix": "+49",
    "code": "DE",
    "icon": "🇩🇪",
    "names": {
      "it": "Germania",
      "de": "Deutschland"
    }
  },
  {
    "name": "Ghana",
    "prefix": "+233",
    "code": "GH",
    "icon": "🇬🇭"
  },
  {
    "name": "Gibraltar",
    "prefix": "+350",
    "code": "GI",
    "icon": "🇬🇮",
    "names": {
      "it": "Gibilterra"
    }
  },
  {
    "name": "Greece",
    "prefix": "+30",
    "code": "GR",
    "icon": "🇬🇷",
    "names": {
      "it": "Grecia",
      "de": "Griechenland"
    }
  },
  {
    "name": "Greenland",
    "prefix": "+299",
    "code": "GL",
    "icon": "🇬🇱",
    "names": {
      "it": "Groenlandia",
      "de": "Grönland"
    }
  },
  {
    "name": "Grenada",
    "prefix": "+1473",
    "code": "GD",
    "icon": "🇬🇩"
  },
  {
    "name": "Guadeloupe",
    "prefix": "+590",
    "code": "GP",
    "icon": "🇬🇵"
  },
  {
    "name": "Guam",
    "prefix": "+1671",
    "code": "GU",
    "icon": "🇬🇺"
  },
  {
    "name": "Guatemala",
    "prefix": "+502",
    "code": "GT",
    "icon": "🇬🇹"
  },
  {
    "name": "Guernsey",
    "prefix": "+44",
    "code": "GG",
    "icon": "🇬🇬"
  },
  {
    "name": "Guinea",
    "prefix": "+224",
    "code": "GN",
    "icon": "🇬🇳"
  },
  {
    "name": "Guinea-Bissau",
    "prefix": "+245",
    "code": "GW",
    "icon": "🇬🇼"
  },
  {
    "name": "Guyana",
    "prefix": "+595",
    "code": "GY",
    "icon": "🇬🇾"
  },
  {
    "name": "Haiti",
    "prefix": "+509",
    "code": "HT",
    "icon": "🇭🇹"
  },
  {
    "name": "Holy See (Vatican City State)",
    "prefix": "+379",
    "code": "VA",
    "icon": "🇻🇦",
    "names": {
      "it": "Città del Vaticano",
      "en": "Vatican City",
      "de": "Staat Vatikanstadt"
    }
  },
  {
    "name": "Honduras",
    "prefix": "+504",
    "code": "HN",
    "icon": "🇭🇳"
  },
  {
    "name": "Hong Kong",
    "prefix": "+852",
    "code": "HK",
    "icon": "🇭🇰"
  },
  {
    "name": "Hungary",
    "prefix": "+36",
    "code": "HU",
    "icon": "🇭🇺",
    "names": {
      "it": "Ungheria",
      "de": "Ungarn"
    }
  },
  {
    "name": "Iceland",
    "prefix": "+354",
    "code": "IS",
    "icon": "🇮🇸",
    "names": {
      "it": "Islanda",
      "de": "Island"
    }
  },
  {
    "name": "India",
    "prefix": "+91",
    "code": "IN",
    "icon": "🇮🇳",
    "names": {
      "de": "Indien"
    }
  },
  {
    "name": "Indonesia",
    "prefix": "+62",
    "code": "ID",
    "icon": "🇮🇩",
    "names": {
      "de": "Indonesien"
    }
  },
  {
    "name": "Iran, Islamic Republic of Persian Gulf",
    "prefix": "+98",
    "code": "IR",
    "icon": "🇮🇷",
    "names": {
      "it": "Iran",
      "en": "Iran",
      "de": "Iran"
    }
  },
  {
    "name": "Iraq",
    "prefix": "+964",
    "code": "IQ",
    "icon": "🇮🇶",
    "names": {
      "de": "Irak"
    }
  },
  {
    "name": "Ireland",
    "prefix": "+353",
    "code": "IE",
    "icon": "🇮🇪",
    "names": {
      "it": "Irlanda",
      "de": "Irland"
    }
  },
  {
    "name": "Isle of Man",
    "prefix": "+44",
    "code": "IM",
    "icon": "🇮🇲",
    "names": {
      "it": "Isola di Man",
      "de": "Insel Man"
    }
  },
  {
    "name": "Israel",
    "prefix": "+972",
    "code": "IL",
    "icon": "🇮🇱",
    "names": {
      "it": "Israele"
    }
  },
  {
    "name": "Italy",
    "prefix": "+39",
    "code": "IT",
    "icon": "🇮🇹",
    "names": {
      "it": "Italia",
      "de": "Italien"
    }
  },
  {
    "name": "Jamaica",
    "prefix": "+1876",
    "code": "JM",
    "icon": "🇯🇲",
    "names": {
      "it": "Giamaica",
      "de": "Jamaika"
    }
  },
  {
    "name": "Japan",
    "prefix": "+81",
    "code": "JP",
    "icon": "🇯🇵",
    "names": {
      "it": "Giappone"
    }
  },
  {
    "name": "Jersey",
    "prefix": "+44",
    "code": "JE",
    "icon": "🇯🇪"
  },
  {
    "name": "Jordan",
    "prefix": "+962",
    "code": "JO",
    "icon": "🇯🇴",
    "names": {
      "it": "Giordania",
      "de": "Jordanien"
    }
  },
  {
    "name": "Kazakhstan",
    "prefix": "+77",
    "code": "KZ",
    "icon": "🇰🇿",
    "names": {
      "it": "Kazakistan",
      "de": "Kasachstan"
    }
  },
  {
    "name": "Kenya",
    "prefix": "+254",
    "code": "KE",
    "icon": "🇰🇪",
    "names": {
      "de": "Kenia"
    }
  },
  {
    "name": "Kiribati",
    "prefix": "+686",
    "code": "KI",
    "icon": "🇰🇮"
  },
  {
    "name": "Korea, Democratic People's Republic of Korea",
    "prefix": "+850",
    "code": "KP",
    "icon": "🇰🇵",
    "names": {
      "it": "Corea del Nord",
      "en": "North Korea",
      "de": "Nordkorea"
    }
  },
  {
    "name": "Korea, Republic of South Korea",
    "prefix": "+82",
    "code": "KR",
    "icon": "🇰🇷",
    "names": {
      "it": "Corea del Sud",
      "en": "South Korea",
      "de": "Südkorea"
    }
  },
  {
    "name": "Kuwait",
    "prefix": "+965",
    "code": "KW",
    "icon": "🇰🇼"
  },
  {
    "name": "Kyrgyzstan",
    "prefix": "+996",
    "code": "KG",
    "icon": "🇰🇬",
    "names": {
      "it": "Kirghizistan",
      "de": "Kirgisistan"
    }
  },
  {
    "name": "Laos",
    "prefix": "+856",
    "code": "LA",
    "icon": "🇱🇦"
  },
  {
    "name": "Latvia",
    "prefix": "+371",
    "code": "LV",
    "icon": "🇱🇻",
    "names": {
      "it": "Lettonia",
      "de": "Lettland"
    }
  },
  {
    "name": "Lebanon",
    "prefix": "+961",
    "code": "LB",
    "icon": "🇱🇧",
    "names": {
      "it": "Libano",
      "de": "Libanon"
    }
  },
  {
    "name": "Lesotho",
    "prefix": "+266",
    "code": "LS",
    "icon": "🇱🇸"
  },
  {
    "name": "Liberia",
    "prefix": "+231",
    "code": "LR",
    "icon": "🇱🇷"
  },
  {
    "name": "Libyan Arab Jamahiriya",
    "prefix": "+218",
    "code": "LY",
    "icon": "🇱🇾",
    "names": {
      "it": "Libia",
      "en": "Libya",
      "de": "Libyen"
    }
  },
  {
    "name": "Liechtenstein",
    "prefix": "+423",
    "code": "LI",
    "icon": "🇱🇮"
  },
  {
    "name": "Lithuania",
    "prefix": "+370",
    "code": "LT",
    "icon": "🇱🇹",
    "names": {
      "it": "Lituania",
      "de": "Litauen"
    }
  },
  {
    "name": "Luxembourg",
    "prefix": "+352",
    "code": "LU",
    "icon": "🇱🇺",
    "names": {
      "it": "Lussemburgo",
      "de": "Luxemburg"
    }
  },
  {
    "name": "Macao",
    "prefix": "+853",
    "code": "MO",
    "icon": "🇲🇴"
  },
  {
    "name": "Macedonia",
    "prefix": "+389",
    "code": "MK",
    "icon": "🇲🇰",
    "names": {
      "en": "North Macedonia",
      "de": "Nordmazedonien"
    }
  },
  {
    "name": "Madagascar",
    "prefix": "+261",
    "code": "MG",
    "icon": "🇲🇬",
    "names": {
      "de": "Madagaskar"
    }
  },
  {
    "name": "Malawi",
    "prefix": "+265",
    "code": "MW",
    "icon": "🇲🇼"
  },
  {
    "name": "Malaysia",
    "prefix": "+60",
    "code": "MY",
    "icon": "🇲🇾",
    "names": {
      "it": "Malesia"
    }
  },
  {
    "name": "Maldives",
    "prefix": "+960",
    "code": "MV",
    "icon": "🇲🇻",
    "names": {
      "it": "Maldive",
      "de": "Malediven"
    }
  },
  {
    "name": "Mali",
    "prefix": "+223",
    "code": "ML",
    "icon": "🇲🇱"
  },
  {
    "name": "Malta",
    "prefix": "+356",
    "code": "MT",
    "icon": "🇲🇹"
  },
  {
    "name": "Marshall Islands",
    "prefix": "+692",
    "code": "MH",
    "icon": "🇲🇭",
    "names": {
      "it": "Isole Marshall",
      "de": "Marshallinseln"
    }
  },
  {
    "name": "Martinique",
    "prefix": "+596",
    "code": "MQ",
    "icon": "🇲🇶"
  },
  {
    "name": "Mauritania",
    "prefix": "+222",
    "code": "MR",
    "icon": "🇲🇷",
    "names": {
      "de": "Mauretanien"
    }
  },
  {
    "name": "Mauritius",
    "prefix": "+230",
    "code": "MU",
    "icon": "🇲🇺"
  },
  {
    "name": "Mayotte",
    "prefix": "+262",
    "code": "YT",
    "icon": "🇾🇹"
  },
  {
    "name": "Mexico",
    "prefix": "+52",
    "code": "MX",
    "icon": "🇲🇽",
    "names": {
      "it": "Messico",
      "de": "Mexiko"
    }
  },
  {
    "name": "Micronesia, Federated States of Micronesia",
    "prefix": "+691",
    "code": "FM",
    "icon": "🇫🇲",
    "names": {
      "it": "Micronesia",
      "en": "Federated States of Micronesia",
      "de": "Mikronesien"
    }
  },
  {
    "name": "Moldova",
    "prefix": "+373",
    "code": "MD",
    "icon": "🇲🇩",
    "names": {
      "it": "Moldavia",
      "de": "Moldawien"
    }
  },
  {
    "name": "Monaco",
    "prefix": "+377",
    "code": "MC",
    "icon": "🇲🇨"
  },
  {
    "name": "Mongolia",
    "prefix": "+976",
    "code": "MN",
    "icon": "🇲🇳",
    "names": {
      "de": "Mongolei"
    }
  },
  {
    "name": "Montenegro",
    "prefix": "+382",
    "code": "ME",
    "icon": "🇲🇪"
  },
  {
    "name": "Montserrat",
    "prefix": "+1664",
    "code": "MS",
    "icon": "🇲🇸"
  },
  {
    "name": "Morocco",
    "prefix": "+212",
    "code": "MA",
    "icon": "🇲🇦",
    "names": {
      "it": "Marocco",
      "de": "Marokko"
    }
  },
  {
    "name": "Mozambique",
    "prefix": "+258",
    "code": "MZ",
    "icon": "🇲🇿",
    "names": {
      "it": "Mozambico",
      "de": "Mosambik"
    }
  },
  {
    "name": "Myanmar",
    "prefix": "+95",
    "code": "MM",
    "icon": "🇲🇲",
    "names": {
      "it": "Birmania"
    }
  },
  {
    "name": "Namibia",
    "prefix": "+264",
    "code": "NA",
    "icon": "🇳🇦"
  },
  {
    "name": "Nauru",
    "prefix": "+674",
    "code": "NR",
    "icon": "🇳🇷"
  },
  {
    "name": "Nepal",
    "prefix": "+977",
    "code": "NP",
    "icon": "🇳🇵"
  },
  {
    "name": "Netherlands",
    "prefix": "+31",
    "code": "NL",
    "icon": "🇳🇱",
    "names": {
      "it": "Paesi Bassi",
      "de": "Niederlande"
    }
  },
  {
    "name": "Netherlands Antilles",
    "prefix": "+599",
    "code": "AN",
    "icon": "🇦🇳"
  },
  {
    "name": "New Caledonia",
    "prefix": "+687",
    "code": "NC",
    "icon": "🇳🇨"
  },
  {
    "name": "New Zealand",
    "prefix": "+64",
    "code": "NZ",
    "icon": "🇳🇿",
    "names": {
      "it": "Nuova Zelanda",
      "de": "Neuseeland"
    }
  },
  {
    "name": "Nicaragua",
    "prefix": "+505",
    "code": "NI",
    "icon": "🇳🇮"
  },
  {
    "name": "Niger",
    "prefix": "+227",
    "code": "NE",
    "icon": "🇳🇪"
  },
  {
    "name": "Nigeria",
    "prefix": "+234",
    "code": "NG",
    "icon": "🇳🇬"
  },
  {
    "name": "Niue",
    "prefix": "+683",
    "code": "NU",
    "icon": "🇳🇺"
  },
  {
    "name": "Norfolk Island",
    "prefix": "+672",
    "code": "NF",
    "icon": "🇳🇫"
  },
  {
    "name": "Northern Mariana Islands",
    "prefix": "+1670",
    "code": "MP",
    "icon": "🇲🇵"
  },
  {
    "name": "Norway",
    "prefix": "+47",
    "code": "NO",
    "icon": "🇳🇴",
    "names": {
      "it": "Norvegia",
      "de": "Norwegen"
    }
  },
  {
    "name": "Oman",
    "prefix": "+968",
    "code": "OM",
    "icon": "🇴🇲"
  },
  {
    "name": "Pakistan",
    "prefix": "+92",
    "code": "PK",
    "icon": "🇵🇰"
  },
  {
    "name": "Palau",
    "prefix": "+680",
    "code": "PW",
    "icon": "🇵🇼"
  },
  {
    "name": "Palestinian Territory, Occupied",
    "prefix": "+970",
    "code": "PS",
    "icon": "🇵🇸",
    "names": {
      "it": "Territori Palestinesi",
      "en": "Palestinian Territories",
      "de": "Palästinensische Autonomiegebiete"
    }
  },
  {
    "name": "Panama",
    "prefix": "+507",
    "code": "PA",
    "icon": "🇵🇦",
    "names": {
      "it": "Panamá"
    }
  },
  {
    "name": "Papua New Guinea",
    "prefix": "+675",
    "code": "PG",
    "icon": "🇵🇬",
    "names": {
      "it": "Papua Nuova Guinea",
      "de": "Papua-Neuguinea"
    }
  },
  {
    "name": "Paraguay",
    "prefix": "+595",
    "code": "PY",
    "icon": "🇵🇾"
  },
  {
    "name": "Peru",
    "prefix": "+51",
    "code": "PE",
    "icon": "🇵🇪",
    "names": {
      "it": "Perù"
    }
  },
  {
    "name": "Philippines",
    "prefix": "+63",
    "code": "PH",
    "icon": "🇵🇭",
    "names": {
      "it": "Filippine",
      "de": "Philippinen"
    }
  },
  {
    "name": "Pitcairn",
    "prefix": "+872",
    "code": "PN",
    "icon": "🇵🇳",
    "names": {
      "it": "Isole Pitcairn"
    }
  },
  {
    "name": "Poland",
    "prefix": "+48",
    "code": "PL",
    "icon": "🇵🇱",
    "names": {
      "it": "Polonia",
      "de": "Polen"
    }
  },
  {
    "name": "Portugal",
    "prefix": "+351",
    "code": "PT",
    "icon": "🇵🇹",
    "names": {
      "it": "Portogallo"
    }
  },
  {
    "name": "Puerto Rico",
    "prefix": "+1939",
    "code": "PR",
    "icon": "🇵🇷"
  },
  {
    "name": "Qatar",
    "prefix": "+974",
    "code": "QA",
    "icon": "🇶🇦",
    "names": {
      "de": "Katar"
    }
  },
  {
    "name": "Romania",
    "prefix": "+40",
    "code": "RO",
    "icon": "🇷🇴",
    "names": {
      "de": "Rumänien"
    }
  },
  {
    "name": "Russia",
    "prefix": "+7",
    "code": "RU",
    "icon": "🇷🇺",
    "names": {
      "de": "Russland"
    }
  },
  {
    "name": "Rwanda",
    "prefix": "+250",
    "code": "RW",
    "icon": "🇷🇼",
    "names": {
      "it": "Ruanda",
      "de": "Ruanda"
    }
  },
  {
    "name": "Reunion",
    "prefix": "+262",
    "code": "RE",
    "icon": "🇷🇪"
  },
  {
    "name": "Saint Barthelemy",
    "prefix": "+590",
    "code": "BL",
    "icon": "🇧🇱"
  },
  {
    "name": "Saint Helena, Ascension and Tristan Da Cunha",
    "prefix": "+290",
    "code": "SH",
    "icon": "🇸🇭",
    "names": {
      "it": "Sant'Elena, Ascensione e Tristan da Cunha",
      "en": "Saint Helena, Ascension and Tristan da Cunha",
      "de": "St. Helena, Ascension und Tristan da Cunha"
    }
  },
  {
    "name": "Saint Kitts and Nevis",
    "prefix": "+1869",
    "code": "KN",
    "icon": "🇰🇳",
    "names": {
      "it": "Saint Kitts e Nevis",
      "de": "St. Kitts und Nevis"
    }
  },
  {
    "name": "Saint Lucia",
    "prefix": "+1758",
    "code": "LC",
    "icon": "🇱🇨",
    "names": {
      "it": "Santa Lucia",
      "de": "St. Lucia"
    }
  },
  {
    "name": "Saint Martin",
    "prefix": "+590",
    "code": "MF",
    "icon": "🇲🇫"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "prefix": "+508",
    "code": "PM",
    "icon": "🇵🇲"
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "prefix": "+1784",
    "code": "VC",
    "icon": "🇻🇨",
    "names": {
      "it": "Saint Vincent e Grenadine",
      "de": "Saint Vincent und die Grenadinen"
    }
  },
  {
    "name": "Samoa",
    "prefix": "+685",
    "code": "WS",
    "icon": "🇼🇸",
    "names": {
      "en": "Sāmoa"
    }
  },
  {
    "name": "San Marino",
    "prefix": "+378",
    "code": "SM",
    "icon": "🇸🇲"
  },
  {
    "name": "Sao Tome and Principe",
    "prefix": "+239",
    "code": "ST",
    "icon": "🇸🇹",
    "names": {
      "it": "São Tomé e Príncipe",
      "en": "São Tomé and Príncipe",
      "de": "São Tomé und Príncipe"
    }
  },
  {
    "name": "Saudi Arabia",
    "prefix": "+966",
    "code": "SA",
    "icon": "🇸🇦",
    "names": {
      "it": "Arabia Saudita",
      "de": "Saudi-Arabien"
    }
  },
  {
    "name": "Senegal",
    "prefix": "+221",
    "code": "SN",
    "icon": "🇸🇳"
  },
  {
    "name": "Serbia",
    "prefix": "+381",
    "code": "RS",
    "icon": "🇷🇸",
    "names": {
      "de": "Serbien"
    }
  },
  {
    "name": "Seychelles",
    "prefix": "+248",
    "code": "SC",
    "icon": "🇸🇨",
    "names": {
      "it": "Seicelle",
      "de": "Seychellen"
    }
  },
  {
    "name": "Sierra Leone",
    "prefix": "+232",
    "code": "SL",
    "icon": "🇸🇱"
  },
  {
    "name": "Singapore",
    "prefix": "+65",
    "code": "SG",
    "icon": "🇸🇬",
    "names": {
      "de": "Singapur"
    }
  },
  {
    "name": "Slovakia",
    "prefix": "+421",
    "code": "SK",
    "icon": "🇸🇰",
    "names": {
      "it": "Slovacchia",
      "de": "Slowakei"
    }
  },
  {
    "name": "Slovenia",
    "prefix": "+386",
    "code": "SI",
    "icon": "🇸🇮",
    "names": {
      "de": "Slowenien"
    }
  },
  {
    "name": "Solomon Islands",
    "prefix": "+677",
    "code": "SB",
    "icon": "🇸🇧",
    "names": {
      "it": "Isole Salomone",
      "de": "Salomonen"
    }
  },
  {
    "name": "Somalia",
    "prefix": "+252",
    "code": "SO",
    "icon": "🇸🇴"
  },
  {
    "name": "South Africa",
    "prefix": "+27",
    "code": "ZA",
    "icon": "🇿🇦",
    "names": {
      "it": "Sudafrica",
      "de": "Südafrika"
    }
  },
  {
    "name": "South Sudan",
    "prefix": "+211",
    "code": "SS",
    "icon": "🇸🇸",
    "names": {
      "it": "Sudan del Sud",
      "de": "Südsudan"
    }
  },
  {
    "name": "South Georgia and the South Sandwich Islands",
    "prefix": "+500",
    "code": "GS",
    "icon": "🇬🇸",
    "names": {
      "it": "Georgia del Sud e isole Sandwich meridionali",
      "en": "South Georgia and South Sandwich Islands",
      "de": "Südgeorgien und die Südlichen Sandwichinseln"
    }
  },
  {
    "name": "Spain",
    "prefix": "+34",
    "code": "ES",
    "icon": "🇪🇸",
    "names": {
      "it": "Spagna",
      "de": "Spanien"
    }
  },
  {
    "name": "Sri Lanka",
    "prefix": "+94",
    "code": "LK",
    "icon": "🇱🇰"
  },
  {
    "name": "Sudan",
    "prefix": "+249",
    "code": "SD",
    "icon": "🇸🇩"
  },
  {
    "name": "Suriname",
    "prefix": "+597",
    "code": "SR",
    "icon": "🇸🇷",
    "names": {
      "de": "Surinam"
    }
  },
  {
    "name": "Svalbard and Jan Mayen",
    "prefix": "+47",
    "code": "SJ",
    "icon": "🇸🇯"
  },
  {
    "name": "Swaziland",
    "prefix": "+268",
    "code": "SZ",
    "icon": "🇸🇿",
    "names": {
      "en": "Eswatini",
      "de": "Eswatini"
    }
  },
  {
    "name": "Sweden",
    "prefix": "+46",
    "code": "SE",
    "icon": "🇸🇪",
    "names": {
      "it": "Svezia",
      "de": "Schweden"
    }
  },
  {
    "name": "Switzerland",
    "prefix": "+41",
    "code": "CH",
    "icon": "🇨🇭",
    "names": {
      "it": "Svizzera",
      "de": "Schweiz"
    }
  },
  {
    "name": "Syrian Arab Republic",
    "prefix": "+963",
    "code": "SY",
    "icon": "🇸🇾",
    "names": {
      "it": "Siria",
      "en": "Syria",
      "de": "Syrien"
    }
  },
  {
    "name": "Taiwan",
    "prefix": "+886",
    "code": "TW",
    "icon": "🇹🇼"
  },
  {
    "name": "Tajikistan",
    "prefix": "+992",
    "code": "TJ",
    "icon": "🇹🇯",
    "names": {
      "it": "Tagikistan",
      "de": "Tadschikistan"
    }
  },
  {
    "name": "Tanzania, United Republic of Tanzania",
    "prefix": "+255",
    "code": "TZ",
    "icon": "🇹🇿",
    "names": {
      "it": "Tanzania",
      "en": "Tanzania",
      "de": "Tansania"
    }
  },
  {
    "name": "Thailand",
    "prefix": "+66",
    "code": "TH",
    "icon": "🇹🇭",
    "names": {
      "it": "Thailandia"
    }
  },
  {
    "name": "Timor-Leste",
    "prefix": "+670",
    "code": "TL",
    "icon": "🇹🇱",
    "names": {
      "it": "Timor Est",
      "en": "East Timor",
      "de": "Osttimor"
    }
  },
  {
    "name": "Togo",
    "prefix": "+228",
    "code": "TG",
    "icon": "🇹🇬"
  },
  {
    "name": "Tokelau",
    "prefix": "+690",
    "code": "TK",
    "icon": "🇹🇰"
  },
  {
    "name": "Tonga",
    "prefix": "+676",
    "code": "TO",
    "icon": "🇹🇴"
  },
  {
    "name": "Trinidad and Tobago",
    "prefix": "+1868",
    "code": "TT",
    "icon": "🇹🇹",
    "names": {
      "it": "Trinidad e Tobago",
      "de": "Trinidad und Tobago"
    }
  },
  {
    "name": "Tunisia",
    "prefix": "+216",
    "code": "TN",
    "icon": "🇹🇳",
    "names": {
      "de": "Tunesien"
    }
  },
  {
    "name": "Turkey",
    "prefix": "+90",
    "code": "TR",
    "icon": "🇹🇷",
    "names": {
      "it": "Turchia",
      "de": "Türkei"
    }
  },
  {
    "name": "Turkmenistan",
    "prefix": "+993",
    "code": "TM",
    "icon": "🇹🇲"
  },
  {
    "name": "Turks and Caicos Islands",
    "prefix": "+1649",
    "code": "TC",
    "icon": "🇹🇨",
    "names": {
      "it": "Turks e Caicos",
      "de": "Turks- und Caicosinseln"
    }
  },
  {
    "name": "Tuvalu",
    "prefix": "+688",
    "code": "TV",
    "icon": "🇹🇻"
  },
  {
    "name": "Uganda",
    "prefix": "+256",
    "code": "UG",
    "icon": "🇺🇬"
  },
  {
    "name": "Ukraine",
    "prefix": "+380",
    "code": "UA",
    "icon": "🇺🇦",
    "names": {
      "it": "Ucraina"
    }
  },
  {
    "name": "United Arab Emirates",
    "prefix": "+971",
    "code": "AE",
    "icon": "🇦🇪",
    "names": {
      "it": "Emirati Arabi Uniti",
      "de": "Vereinigte Arabische Emirate"
    }
  },
  {
    "name": "United Kingdom",
    "prefix": "+44",
    "code": "GB",
    "icon": "🇬🇧",
    "names": {
      "it": "Regno Unito",
      "de": "Vereinigtes Königreich"
    }
  },
  {
    "name": "United States",
    "prefix": "+1",
    "code": "US",
    "icon": "🇺🇸",
    "names": {
      "it": "Stati Uniti d'America",
      "en": "United States of America",
      "de": "Vereinigte Staaten von Amerika"
    }
  },
  {
    "name": "Uruguay",
    "prefix": "+598",
    "code": "UY",
    "icon": "🇺🇾"
  },
  {
    "name": "Uzbekistan",
    "prefix": "+998",
    "code": "UZ",
    "icon": "🇺🇿",
    "names": {
      "de": "Usbekistan"
    }
  },
  {
    "name": "Vanuatu",
    "prefix": "+678",
    "code": "VU",
    "icon": "🇻🇺"
  },
  {
    "name": "Venezuela, Bolivarian Republic of Venezuela",
    "prefix": "+58",
    "code": "VE",
    "icon": "🇻🇪",
    "names": {
      "it": "Venezuela",
      "en": "Venezuela",
      "de": "Venezuela"
    }
  },
  {
    "name": "Vietnam",
    "prefix": "+84",
    "code": "VN",
    "icon": "🇻🇳"
  },
  {
    "name": "Virgin Islands, British",
    "prefix": "+1284",
    "code": "VG",
    "icon": "🇻🇬",
    "names": {
      "it": "Isole Vergini Britanniche",
      "en": "British Virgin Islands",
      "de": "Britische Jungferninseln"
    }
  },
  {
    "name": "Virgin Islands, U.S.",
    "prefix": "+1340",
    "code": "VI",
    "icon": "🇻🇮"
  },
  {
    "name": "Wallis and Futuna",
    "prefix": "+681",
    "code": "WF",
    "icon": "🇼🇫"
  },
  {
    "name": "Yemen",
    "prefix": "+967",
    "code": "YE",
    "icon": "🇾🇪",
    "names": {
      "de": "Jemen"
    }
  },
  {
    "name": "Zambia",
    "prefix": "+260",
    "code": "ZM",
    "icon": "🇿🇲",
    "names": {
      "de": "Sambia"
    }
  },
  {
    "name": "Zimbabwe",
    "prefix": "+263",
    "code": "ZW",
    "icon": "🇿🇼",
    "names": {
      "de": "Simbabwe"
    }
  }
]
